import { render, staticRenderFns } from "./SiblingsSection.vue?vue&type=template&id=1242c8b6&scoped=true"
import script from "./SiblingsSection.vue?vue&type=script&lang=js"
export * from "./SiblingsSection.vue?vue&type=script&lang=js"
import style0 from "./SiblingsSection.vue?vue&type=style&index=0&id=1242c8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242c8b6",
  null
  
)

export default component.exports